import ApplicationState from "@insite/client-framework/Store/ApplicationState";

import { DanaGeneralSettingModel, DanaProductListSettingModel } from "@dana/Types/ApiModels";

export function getDanaGeneralSettings(state: ApplicationState) {
    return state.context.settings.settingsCollection.danaGeneralSettings as DanaGeneralSettingModel | undefined;
}
export function getDanaProductListSettings(state: ApplicationState) {
    return state.context.settings.settingsCollection.productListSettings as DanaProductListSettingModel | undefined;
}

